import React, { useState, useRef } from 'react';
import { EntityTypes } from 'context/entityContext';
import debounce from 'lodash.debounce';
import capitalize from 'lodash.capitalize';

import pluralize from 'helpers/pluralize';

import useOnClickOutside from 'hooks/useOnClickOutside';

import { Button, Caret, Wrapper } from './ViewRelatedMenu.styles';
import NumberLoading from './NumberLoading';
import Modal from './Modal';

interface IViewRelatedMenuProps {
  entityType: EntityTypes;
  browseEntityType: string;
  entityIds: string[];
  artistsDisplayName?: string;
  total?: number;
}

const ViewRelatedMenu: React.FC<IViewRelatedMenuProps> = (props) => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const modalRef = useRef<HTMLDivElement>(null);

  const { browseEntityType, entityType, entityIds, artistsDisplayName, total } =
    props;

  useOnClickOutside(modalRef, () => {
    if (isOpenModal) {
      setIsOpenModal(false);
    }
  });

  const entityTitle = pluralize(
    browseEntityType === 'album' ? 'release' : browseEntityType,
    total
  );

  const searchText = `Search ${artistsDisplayName || ''} ${capitalize(
    entityTitle
  )}`;

  return (
    <Wrapper ref={modalRef}>
      <Button onClick={debounce((): any => setIsOpenModal(!isOpenModal), 10)}>
        {total ?? <NumberLoading />}
        &nbsp;
        {entityTitle}
        <Caret open={isOpenModal} />
      </Button>
      {isOpenModal && (
        <Modal
          browseEntityType={browseEntityType}
          entityType={entityType}
          entityIds={entityIds}
          searchText={searchText}
        />
      )}
    </Wrapper>
  );
};

export default ViewRelatedMenu;
